(async () => {
  const container = document.getElementById("js-newsPost");
  if (!container) return;

  try {
    const endpoint = `${location.origin}/wp-json/wp/v2/posts?per_page=1&_embed=1`;
    const res = await fetch(endpoint, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch");

    const [post] = await res.json();
    if (!post) return;

    const title = post.title.rendered;
    const url = post.link;
    const dateISO = post.date;
    const dateText = new Date(dateISO).toLocaleDateString("ja-JP", {
      year: "numeric", month: "long", day: "numeric"
    });

    // カテゴリは必ず1つ以上ある前提
    const cat = post._embedded["wp:term"][0][0];
    const catName = cat.name;
    const catLink = cat.link;

    container.innerHTML = `
      <!-- .c-card -->
      <div class="c-card -type2">
        <div class="c-card__cols">
          <div class="c-card__col">
            <ul class="c-card__metaList">
              <li>
                <p class="c-card__date">
                  <time datetime="${dateISO}">${dateText}</time>
                </p>
              </li>
              <li>
                <a href="${catLink}" class="c-card__category">${catName}</a>
              </li>
            </ul>
          </div>
          <div class="c-card__col">
            <p class="c-card__heading"><a href="${url}">${title}</a></p>
          </div>
        </div>
      </div>
      <!-- /.c-card -->
    `;
  } catch (e) {
    console.error(e); // デバッグ用ログだけ残す
  }
})();
